import SimpleThread from './SimpleThread';
import SimpleThreadContainer from './SimpleThread.container';
export default SimpleThreadContainer(SimpleThread);

//# sourceMappingURL=index.js.map